<template>
  <a
    class="filter-button"
    :class="{ active: isActive }"
    @click="$emit('filterClicked')"
  >
    {{ filterTitle }}

    <CloseIconV2
      v-if="isActive && showCloseIcon"
      class="close-icon"
      @click="$emit('clearFilter', $event)"
    />
  </a>
</template>

<script>
import CloseIconV2 from '~/components/Common/Svg/CloseIconV2.vue';

export default {
  components: {
    CloseIconV2,
  },
  props: {
    isActive: {
      type: Boolean,
      default: false,
    },
    filterTitle: {
      type: String,
      required: true,
    },
    showCloseIcon: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['filterClicked', 'clearFilter'],
};
</script>

<style lang="scss" scoped>
@import './FilterButton.scss';
</style>
